<script setup>
import { ref, onMounted ,computed} from "vue";
import api from "@/services/apiService";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
// import ProfileCard from "@/views/pages/Profile/ProfileCard.vue";

const user = ref(JSON.parse(localStorage.getItem("userData")));
const cities = ref([]);
const selectedCityId = ref("");
const successMessage = ref("");
const errorMessage = ref("");

// Load cities from API
const fetchCities = async () => {
  try {
    const response = await api.get("/cities?pagination=false");
    cities.value = response.data.member || [];

    // Try to auto-select current city
    const matched = cities.value.find(c => c.name === user.value.city);
    selectedCityId.value = matched?.id || "";
  } catch (err) {
    errorMessage.value = "Error al cargar ciudades.";
  }
};

// Save profile
const saveProfile = async () => {
  successMessage.value = "";
  errorMessage.value = "";

  try {
    await api.patch("/me", {
      fullName: user.value.fullName,
      email: user.value.email,
      city: `/api/cities/${selectedCityId.value}`
    });

    const updatedCity = cities.value.find(c => c.id === selectedCityId.value);
    user.value.city = updatedCity?.name || "";
    user.value.country = updatedCity?.country || "";

    // Update localStorage
    localStorage.setItem("userData", JSON.stringify(user.value));
    successMessage.value = "Perfil actualizado correctamente.";
  } catch (err) {
    errorMessage.value = err.response?.data?.error || "Error al guardar el perfil.";
  }
};
const getMainRole = computed(() => {
  const roles = user.value?.roles || [];

  if (roles.includes("ROLE_ADMIN")) return "Admin";
  if (roles.includes("ROLE_AGENT")) return "Agente";
  if (roles.includes("ROLE_USER")) return "Usuario";

  return "Sin rol";
});

onMounted(() => {
  if (user.value) {
    fetchCities();
  } else {
    errorMessage.value = "Usuario no encontrado en localStorage.";
  }
});
</script>

<template>
  <main>
    <div class="container-fluid">
      <div
        class="page-header min-height-300"
        style="background-image: url('https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?auto=format&fit=crop&w=1920&q=80'); margin-right: -24px; margin-left: -34%;"
      >
        <span class="mask bg-gradient-success opacity-6"></span>
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <img src="../assets/img/team-1.png" alt="profile_image" class="shadow-sm w-100 border-radius-lg" />
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{ user.fullname }}</h5>
                <p class="mb-0 font-weight-bold text-sm">{{ getMainRole }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Edit Profile</p>
                <argon-button color="success" size="sm" class="ms-auto" @click="saveProfile">Save</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">User Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label class="form-control-label">Full Name</label>
                  <argon-input type="text" v-model="user.fullname" />
                </div>
                <div class="col-md-6">
                  <label class="form-control-label">Email address</label>
                  <argon-input type="email" disabled v-model="user.email" />
                </div>
              </div>

              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">Contact Information</p>
              <div class="row">
                
                <div class="col-md-4">
                  <label class="form-control-label">City</label>
                  <select v-model="selectedCityId" class="form-select">
                    <option disabled value="">Selecciona una ciudad</option>
                    <option v-for="c in cities" :key="c.id" :value="c.id">{{ c.name }}</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-control-label">Country</label>
                  <argon-input type="text" v-model="user.country" disabled />
                </div>
              </div>

              <div v-if="successMessage" class="alert alert-success mt-3">
                {{ successMessage }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger mt-3">
                {{ errorMessage }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <profile-card />
        </div>
      </div>
    </div>
  </main>
</template>
